export enum Payout {
  REVIEW_PAYOUT_REQUEST = '@payout/REVIEW_PAYOUT_REQUEST',
  REVIEW_PAYOUT_SUCCESS = '@payout/REVIEW_PAYOUT_SUCCESS',
  REVIEW_PAYOUT_FAIL = '@payout/REVIEW_PAYOUT_FAIL',

  GET_USER_PAYOUT_REQUEST = '@payout/GET_USER_PAYOUT_REQUEST',
  GET_USER_PAYOUT_SUCCESS = '@payout/GET_USER_PAYOUT_SUCCESS',
  GET_USER_PAYOUT_FAIL = '@payout/GET_USER_PAYOUT_FAIL',

  GET_USER_PAYOUT_CALCULATIONS_REQUEST = '@payout/GET_USER_PAYOUT_CALCULATIONS_REQUEST',
  GET_USER_PAYOUT_CALCULATIONS_SUCCESS = '@payout/GET_USER_PAYOUT_CALCULATIONS_SUCCESS',
  GET_USER_PAYOUT_CALCULATIONS_FAIL = '@payout/GET_USER_PAYOUT_CALCULATIONS_FAIL',
}
